import type { Collection } from '@/utils/types/collections'

export async function collectionsFetcher(url: string): Promise<{ collections: Collection[] }> {
	const controller = new AbortController()
	const timeout = setTimeout(() => controller.abort(), 10_000)
	try {
		const response = await fetch(url, { signal: controller.signal })
		if (!response.ok) throw new Error(`Collections request failed: ${response.status}`)
		const data = await response.json()
		if (!Array.isArray(data?.collections)) throw new Error('Invalid collections response')
		return data
	} finally {
		clearTimeout(timeout)
	}
}
